import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Burger, Group, UnstyledButton, Text, rem, Menu, ActionIcon, Modal, Button } from '@mantine/core';
import { IconSettings, IconUser, IconDownload, IconUsersGroup } from '@tabler/icons-react'; // ✅ added
import { useDisclosure } from '@mantine/hooks';
import classes from '../css/MobileNavbar.module.css';
import { downloadFile, get } from './Request';
import { useUser } from './Context';
import KeyManagementModal from './KeyManagementModal';

export default function HeaderApp() {
  const [opened, { toggle }] = useDisclosure();
  const [modalOpened, setModalOpened] = useState(false);
  const [extractionModalOpened, setExtractionModalOpened] = useState(false);
  const [userExist, setUserExist] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const groupName = localStorage.getItem('groupName');

  const navigate = useNavigate();
  const { refresh } = useUser();
  const user = useUser();

  useEffect(() => {
    const adminStatus = localStorage.getItem('isAdmin') === 'true';
    setIsAdmin(adminStatus);
  }, []);

  const handleDownloadFile = async () => {
    try {
      const response = await downloadFile(`userData`, localStorage.getItem('userToken'));

      const contentDisposition = response.headers['content-disposition'];
      const fileName = contentDisposition ? contentDisposition.split('filename=')[1].replace(/"/g, '') : 'downloaded_file';

      const blob = new Blob([response.data], { type: response.headers['content-type'] });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  };

  const handleCheckToken = async () => {
    if (localStorage.getItem('userToken')) {
      try {
        const response = await get('checkToken', null, localStorage.getItem('userToken'));
        setUserExist(!!response.exists);
      } catch (error) {
        console.error('Error checking token:', error);
        setUserExist(false);
      }
    } else {
      setUserExist(false);
    }
  };

  useEffect(() => {
    handleCheckToken();
  }, [user, refresh]);

  return (
    <>
      <Group h="100%" px="md">
        <Burger opened={opened} onClick={toggle} hiddenFrom="sm" size="sm" />
        <Group justify="space-between" style={{ flex: 1 }}>
          <Group>
            <Text fw={700} ml={20} style={{ fontSize: '1.8rem' }}>
              DataLock
            </Text>

            {/* ✅ prettier group pill */}
            {groupName && (
              <Group
                gap={6}
                px="sm"
                py={4}
                style={{
                  borderRadius: rem(999),
                  background: 'var(--mantine-color-default)',
                  border: '1px solid var(--mantine-color-default-border)'
                }}>
                <IconUsersGroup size={16} style={{ opacity: 0.8 }} />
                <Text size="sm" fw={600} style={{ maxWidth: 220 }} lineClamp={1}>
                  {groupName}
                </Text>
              </Group>
            )}
          </Group>

          <Group ml="xl" gap={0} visibleFrom="sm">
            <UnstyledButton className={classes.control} onClick={() => navigate('/')}>
              Accueil
            </UnstyledButton>
            <UnstyledButton onClick={() => window.open('/docs/docs/intro', '_blank')} className={classes.control}>
              Documentation
            </UnstyledButton>

            {userExist && (
              <Menu shadow="md" width={200}>
                <Menu.Target>
                  <ActionIcon size="lg" variant="light">
                    <IconSettings style={{ width: '60%', height: '60%' }} />
                  </ActionIcon>
                </Menu.Target>
                <Menu.Dropdown>
                  <Menu.Item size="lg" variant="transparent" leftSection={<IconUser style={{ width: rem(14), height: rem(14) }} />} onClick={() => setModalOpened(true)}>
                    Clés de chiffrement
                  </Menu.Item>

                  {isAdmin && (
                    <Menu.Item
                      size="lg"
                      variant="transparent"
                      leftSection={<IconDownload style={{ width: rem(14), height: rem(14) }} />}
                      onClick={() => setExtractionModalOpened(true)}>
                      Extraction
                    </Menu.Item>
                  )}
                </Menu.Dropdown>
              </Menu>
            )}
          </Group>
        </Group>
      </Group>

      <KeyManagementModal opened={modalOpened} defaultTab="saved" onClose={() => setModalOpened(false)} />

      <Modal opened={extractionModalOpened} onClose={() => setExtractionModalOpened(false)} title="Confirmation d'extraction" centered>
        <Text mb="md">
          L'extraction contient les différents modèles créés par les utilisateurs présents dans le groupe ainsi que les adresses liées à ceux-ci. Cette extraction permet de
          récupérer les différentes attestations créées sur DataLock si DataLock venait à disparaître.
        </Text>
        <Button
          onClick={() => {
            handleDownloadFile();
            setExtractionModalOpened(false);
          }}
          fullWidth>
          Télécharger
        </Button>
      </Modal>
    </>
  );
}
